var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61905 7.2381C5.51322 7.2381 6.2381 6.51322 6.2381 5.61905C6.2381 4.72487 5.51322 4 4.61905 4C3.72487 4 3 4.72487 3 5.61905C3 6.51322 3.72487 7.2381 4.61905 7.2381ZM13.9286 9.85714C11.5748 9.85714 9.66667 11.7653 9.66667 14.119V20.1905C9.66667 20.7428 9.21895 21.1905 8.66667 21.1905C8.11438 21.1905 7.66667 20.7428 7.66667 20.1905V14.119C7.66667 10.6607 10.4702 7.85714 13.9286 7.85714C17.3869 7.85714 20.1905 10.6607 20.1905 14.119V20.1905C20.1905 20.7428 19.7428 21.1905 19.1905 21.1905C18.6382 21.1905 18.1905 20.7428 18.1905 20.1905V14.119C18.1905 11.7653 16.2824 9.85714 13.9286 9.85714ZM4.61905 8.66667C5.17133 8.66667 5.61905 9.11438 5.61905 9.66667L5.61905 20.1905C5.61905 20.7428 5.17133 21.1905 4.61905 21.1905C4.06676 21.1905 3.61905 20.7428 3.61905 20.1905L3.61905 9.66667C3.61905 9.11438 4.06676 8.66667 4.61905 8.66667Z",
    fill: "white",
    fillOpacity: 0.56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.c5a0ee629fcfc6dd321b17c82efd9e86.svg";
export { ForwardRef as ReactComponent };